const handleSubcategoryCarousel = {
  init: () => {
    handleSubcategoryCarousel.main()
  },

  main: () => {
    const styles = {
      disabled: {
        backgroundColor: '#D9DBDA',
        textColor: '#4b4b4b',
      },
      enabled: {
        backgroundColor: '#5812CD',
        textColor: '#ffffff',
      },
    }

    const carousels = handleSubcategoryCarousel.getFeaturedCarousels()
    if (carousels.length === 0) return

    handleSubcategoryCarousel.handleButtonStyles(styles, carousels)
    handleSubcategoryCarousel.updateSlideAttributes(carousels)

    window.addEventListener('nova:resize-width', () =>
      handleSubcategoryCarousel.updateSlideAttributes(carousels)
    )
  },

  updateSlideAttributes: (carousels) => {
    for (const carousel of carousels) {
      const viewport = handleSubcategoryCarousel.getViewport();
      switch (viewport) {
        case 'small-mobile':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 1, 'auto')
          break
        case 'mobile':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 1, 'auto')
          break
        case 'tablet':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 2, 'auto')
          break
        case 'large-tablet':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 2, 'auto')
          break
        case 'desktop':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 3, 'auto')
          break
        case 'large-desktop':
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 5, 'auto')
          break
        default:
          handleSubcategoryCarousel.setCarouselAttributes(carousel, 4, 'auto')
          break
      }
    }
  },

  setCarouselAttributes: (carousel, slidesPerPage, aspectRatio) => {
    carousel.setAttribute('slides-per-page', slidesPerPage)
    carousel.setAttribute('style', `--aspect-ratio: ${aspectRatio}`)
  },

  getFeaturedCarousels: () => {
    return Array.from(
      document.querySelectorAll('.js-sub-category-carousel')
    )
  },

  updateButtonStyles: (button, styles) => {
    button.style.opacity = 1
    const slot = button.querySelector('slot')
    const assignedNodes = slot.assignedNodes({ flatten: true })
    const isDisabled = button.classList.contains(
      'carousel__navigation-button--disabled'
    )
    const { backgroundColor, textColor } = isDisabled
      ? styles.disabled
      : styles.enabled

    for (const node of assignedNodes) {
      node.style.backgroundColor = backgroundColor
      for (const path of node.querySelectorAll('path')) {
        path.style.stroke = textColor
      }
    }
  },

  updateDisabledButtonStyles: (button, styles) => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          handleSubcategoryCarousel.updateButtonStyles(button, styles)
        }
      }
    })
    observer.observe(button, { attributes: true })
  },

  handleButtonStyles(styles, carousels) {
    for (const carousel of carousels) {
      handleSubcategoryCarousel.applyStylesToButtons(carousel, styles)

      const observer = new MutationObserver(() => {
        handleSubcategoryCarousel.applyStylesToButtons(carousel, styles)

        observer.disconnect()
      })

      observer.observe(carousel.shadowRoot, { childList: true, subtree: true })
    }
  },

  applyStylesToButtons: (carousel, styles) => {
    const buttons = carousel.shadowRoot.querySelectorAll('button')
    for (const button of buttons) {
      handleSubcategoryCarousel.updateButtonStyles(button, styles)
      handleSubcategoryCarousel.updateDisabledButtonStyles(button, styles)
    }
  },

  getViewport: () => {
    const width = window.innerWidth
    if (width <= 400) {
      return 'small-mobile'
    } else if (width > 400 && width <= 480) {
      return 'mobile'
    } else if (width > 480 && width <= 768) {
      return 'tablet'
    } else if (width > 768 && width <= 990) {
      return 'large-tablet'
    } else if (width > 990 && width <= 1440) {
      return 'desktop'
    } else {
      return 'large-desktop'
    }
  }
}

handleSubcategoryCarousel.init()
